import { TableGridHeader } from './table-grid.model';
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-table-grid',
  templateUrl: './table-grid.component.html',
  styleUrls: ['./table-grid.component.scss']
})
export class TableGridComponent implements OnInit {

  @Input() headers: TableGridHeader[];
  @Input() data: Array<any>;
  @Input() searchText?: string;
  @Input() showCount = false;
  @Input() noRecordTxt = 'No record found.';

  @Output() onRowSelect = new EventEmitter();
  @Output() onDelete = new EventEmitter();
  @Output() onEdit = new EventEmitter();
  @Output() onDownload = new EventEmitter();
  @Output() onLock = new EventEmitter();
  @Output() onLink = new EventEmitter();
  cloneData: Array<any>;
  public defaultSort: TableGridHeader;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.headers && changes.headers.currentValue) {
      this.headers.forEach(element => {
        if(!element.sort) {
          element.sort = 'none';
        } else {
          this.defaultSort = element;
        }
      });
    }

    if (changes && changes.data && changes.data.currentValue) {
      this.cloneData = JSON.parse(JSON.stringify(changes.data.currentValue));
      if(this.defaultSort) {
        this.sortData(this.defaultSort);
      }
    }
  }

  ngOnInit(): void {
  }

  onSelect(item) {
    this.onRowSelect.emit(item);
  }

  sortData(header) {
    if (header.sort === 'none') {
      header.sort = 'desc';
      this.sortInDescOrder(header);
    } else if (header.sort === 'desc') {
      header.sort = 'asc';
      this.sortInAscOrder(header);
    } else if (header.sort === 'asc') {
      header.sort = 'none';
      this.setDefaultState();
    }

    this.headers.forEach(element => {
      if (header.name !== element.name) {
        element.sort = 'none';
      }
    });

  }

  sortInAscOrder(header) {
    this.data.sort((a, b) => {
      let item1;
      let item2;
      if (header.sortType === 'string') {
        // Use toUpperCase() to ignore character casing
        item1 = a[header.key] ? a[header.key].toUpperCase() : '';
        item2 = b[header.key] ? b[header.key].toUpperCase() : '';
      } else if (header.sortType === 'number') {
        item1 = a[header.key] ? Number(a[header.key]) : 0;
        item2 = b[header.key] ? Number(b[header.key]) : 0;
      } else if (header.sortType === 'date') {
        item1 = a[header.key] ? new Date(a[header.key]).getTime() : '';
        item2 = b[header.key] ? new Date(b[header.key]).getTime() : '';
      }
      if (item1 > item2) {
        return -1;
      } else if (item1 < item2) {
        return 1;
      }
      return 0;
    });
  }

  sortInDescOrder(header) {
    this.data.sort((a, b) => {
      // Use toUpperCase() to ignore character casing
      let item1;
      let item2;
      if (header.sortType === 'string') {
        // Use toUpperCase() to ignore character casing
        item1 = a[header.key] ? a[header.key].toUpperCase() : '';
        item2 = b[header.key] ? b[header.key].toUpperCase() : '';
      } else if (header.sortType === 'number') {
        item1 = a[header.key] ? Number(a[header.key]) : 0;
        item2 = b[header.key] ? Number(b[header.key]) : 0;
      } else if (header.sortType === 'date') {
        item1 = a[header.key] ? new Date(a[header.key]).getTime() : '';
        item2 = b[header.key] ? new Date(b[header.key]).getTime() : '';
      }

      if (item1 > item2) {
        return 1;
      } else if (item1 < item2) {
        return -1;
      }
      return 0;
    });
  }

  setDefaultState() {
    this.data = JSON.parse(JSON.stringify(this.cloneData));
  }

  edit(item) {
    this.onEdit.emit(item);
  }

  delete(item) {
    this.onDelete.emit(item);
  }

  download(item) {
    this.onDownload.emit(item);
  }

  lock(item) {
    this.onLock.emit(item);
  }

  link(item) {
    this.onLink.emit(item);
  }
}
